var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"elevation":"8"}},[_c('v-slide-group',{ref:"slideGroup",staticClass:"pa-1",attrs:{"mandatory":"","show-arrows":"","value":_vm.selectedLayer},on:{"change":_vm.onSelectLayer}},_vm._l((_vm.displayedLayers),function(layer){return _c('v-slide-item',{key:layer.lid,attrs:{"value":layer},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var active = ref.active;
var toggle = ref.toggle;
return [_c('v-card',{class:{
          'ma-1': true,
          'secondary': active,
          'onsecondary--text': active
        },attrs:{"hover":"","width":_vm.imageWidth},on:{"click":toggle}},[_c('wgu-layerpreviewimage',{attrs:{"layer":layer,"mapView":_vm.map.getView(),"width":_vm.imageWidth,"height":_vm.imageHeight,"previewIcon":_vm.previewIcon}}),_vm._v(" "),_c('v-card-title',{staticClass:"caption"},[_c('span',{staticClass:"d-inline-block text-truncate"},[_vm._v("\n            "+_vm._s(layer.get('name'))+"\n          ")])])],1)]}}],null,true)})}),1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ccfaa73","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bglayerswitcher/BgLayerList.vue
// module id = BjgK
// module chunks = 1